export default {
  SHORT_TEXT: 'SHORT_TEXT',
  PARAGRAPH_TEXT: 'PARAGRAPH_TEXT',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  PHONE_NUMBER: 'PHONE_NUMBER',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  GDPR: 'GDPR',
  CONSENT_PRIVACY: 'CONSENT_PRIVACY',
  DATE: 'DATE',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  ADDRESS: 'ADDRESS',
  NUMBER: 'NUMBER',
  URL: 'URL',
  RANGE: 'RANGE',
  NPS: 'NPS',
  YES_NO: 'YES_NO',
  FILE_UPLOAD: 'FILE_UPLOAD',
  SIGNATURE: 'SIGNATURE',
  PAYMENT: 'PAYMENT'
}
